// @flow

import type {PhaseState} from "../components/CalculationPhaseInput";
import OptionManager from "./OptionManager";
import DependencyManager from "./DependencyManager";
import type {ProjectUiInput} from "../store/Calculation";

type ErrorsAndTouched = {
    error: {[name:string]: ?string},
    touched: {[name:string]: boolean}
}


export default class ValidationManager {

    optionManager: OptionManager;
    dependencyManager: DependencyManager;

    constructor(optionManager: OptionManager, dependencyManager: DependencyManager) {
        this.optionManager = optionManager;
        this.dependencyManager = dependencyManager;
    };

    validateText(htmlName: string, value: string): true | string {
        if(htmlName === 'projectName' && value === '')
            return "Projektnamn måste anges";
        if(htmlName === 'personName' && value === '')
            return "Användare måste anges";
        if(htmlName === 'organisationName' && value === '')
            return "Organisation måste anges";
        
        return true;
    }

    vText(fieldName: string, state: ProjectUiInput, errorsAndTouchedObj: ErrorsAndTouched): ErrorsAndTouched {
        let validationResult = this.validateText(fieldName, state[fieldName]);
        return {
            error: this.addValidationResultToErrorObj(errorsAndTouchedObj.error, fieldName, validationResult),
            touched: {...errorsAndTouchedObj.touched, [fieldName]: true}
        };
    }

    validateAllText(state: ProjectUiInput): ErrorsAndTouched {

        let newStatus = {
            error: state.error,
            touched: state.touched
        };

        newStatus = this.vText('projectName', state, newStatus);
        newStatus = this.vText('personName', state, newStatus);
        newStatus = this.vText('organisationName', state, newStatus);
        
        return newStatus;
    }
    

        // Only isolated call when actually changed in UI. 
    validate(htmlName: string, value: number): true | string {
        if(htmlName === 'techniquesToCompare' && value === -1)
            return "Val av teknik måste göras";
        else if(htmlName === 'typeOfLandscapeBefore' && value === -1)
            return "Typ av landskap före måste väljas";
        else if(htmlName === 'coatingBefore' && value === -1)
            return "Beläggning före måste väljas";
        else if(htmlName === 'streetTypeBefore' && value === -1)
            return "Gatutyp före måste väljas";

        else if(htmlName === 'typeOfLandscapeAfter' && value === -1)
            return "Typ av landskap efter måste väljas";
        else if(htmlName === 'coatingAfter' && value === -1)
            return "Beläggning efter måste väljas";
        else if(htmlName === 'streetTypeAfter' && value === -1)
            return "Gatutyp efter måste väljas";
        else if(htmlName === 'asphaltTypeAfter' && value === -1)
            return "Asfaltstyp efter måste väljas";

        else if(htmlName === 'distanceReceiverFillingKm' && value <= 0)
            return "Avstånd till mottagare av fyllnadsmassor måste vara större än 0";
        else if(htmlName === 'distanceReceiverCleanAsphaltKm' && value <= 0)
            return "Avstånd till mottagare av asfalt måste vara större än 0";
        else if(htmlName === 'distanceReceiverPollutedAsphaltKm' && value <= 0)
            return "Avstånd till mottagare av förorenad asfalt måste vara större än 0";
        else if(htmlName === 'distanceFillingKm' && value <= 0)
            return "Avstånd till upplag av fyllnadsmassor måste vara större än 0";
        else if(htmlName === 'distanceAsphaltKm' && value <= 0)
            return "Avstånd till upplag av asfalt måste vara större än 0";
        else if(htmlName === 'distanceReceiverOldTubesKm' && value <= 0)
            return "Avstånd till mottagare av befintliga rör och rörspill måste vara större än 0";
        
        else if(htmlName === 'shaftDepthM' && value <= 0)
            return "Schaktdjup traditionell schakt måste vara större än 0";
        else if(htmlName === 'slopeAngleN1' && value === -1)
            return "Släntlutning traditionell schakt måste väljas";
        else if(htmlName === 'shaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet traditionell schakt måste vara större än 0";
        else if(htmlName === 'shaftLengthM' && value <= 0)
            return "Schaktlängd traditionell schakt måste vara större än 0";
        
        else if(htmlName === 'iflPointShafts' && value < 0)
            return "Antal punktschakter infodring flexibla foder måste anges";
        else if(htmlName === 'iflMetersLongerBottomLengthThanWidth' && value < 0)
            return "Meter längre bottenlängd än bottenbredd infodring flexibla foder måste vara 0 eller större";
        else if(htmlName === 'iflShaftDepthM' && value <= 0)
            return "Schaktdjup infodring flexibla foder måste vara större än 0";
        else if(htmlName === 'iflSlopeAngleN1' && value === -1)
            return "Släntlutning infodring flexibla foder måste väljas";
        else if(htmlName === 'iflShaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet infodring flexibla foder måste vara större än 0";
        else if(htmlName === 'iflShaftLengthM' && value <= 0)
            return "Etapplängd infodring flexibla foder måste vara större än 0";

        else if(htmlName === 'tcPointShafts' && value < 0)
            return "Antal punktschakter rörspräckning måste anges";
        else if(htmlName === 'tcMetersLongerBottomLengthThanWidth' && value < 0)
            return "Meter längre bottenlängd än bottenbredd rörspräckning måste vara 0 eller större";
        else if(htmlName === 'tcShaftDepthM' && value <= 0)
            return "Schaktdjup rörspräckning måste vara större än 0";
        else if(htmlName === 'tcSlopeAngleN1' && value === -1)
            return "Släntlutning rörspräckning måste väljas";
        else if(htmlName === 'tcShaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet rörspräckning måste vara större än 0";
        else if(htmlName === 'tcShaftLengthM' && value <= 0)
            return "Etapplängd rörspräckning måste vara större än 0";
        
        else if(htmlName === 'ddPointShafts' && value < 0)
            return "Antal punktschakter styrd borrning måste anges";
        else if(htmlName === 'ddMetersLongerBottomLengthThanWidth' && value < 0)
            return "Meter längre bottenlängd än bottenbredd styrd borrning måste vara 0 eller större";
        else if(htmlName === 'ddShaftDepthM' && value <= 0)
            return "Schaktdjup styrd borrning måste vara större än 0";
        else if(htmlName === 'ddSlopeAngleN1' && value === -1)
            return "Släntlutning styrd borrning måste väljas";
        else if(htmlName === 'ddShaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet styrd borrning måste vara större än 0";
        else if(htmlName === 'ddShaftLengthM' && value <= 0)
            return "Etapplängd styrd borrning måste vara större än 0";

        else if(htmlName === 'slPointShafts' && value < 0)
            return "Antal punktschakter sliplining måste anges";
        else if(htmlName === 'slMetersLongerBottomLengthThanWidth' && value < 0)
            return "Meter längre bottenlängd än bottenbredd sliplining måste vara 0 eller större";
        else if(htmlName === 'slShaftDepthM' && value <= 0)
            return "Schaktdjup sliplining måste vara större än 0";
        else if(htmlName === 'slSlopeAngleN1' && value === -1)
            return "Släntlutning sliplining måste väljas";
        else if(htmlName === 'slShaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet sliplining måste vara större än 0";
        else if(htmlName === 'slShaftLengthM' && value <= 0)
            return "Etapplängd sliplining måste vara större än 0";

        else if(htmlName === 'pulPointShafts' && value < 0)
            return "Antal punktschakter PU lining måste anges";
        else if(htmlName === 'pulMetersLongerBottomLengthThanWidth' && value < 0)
            return "Meter längre bottenlängd än bottenbredd PU lining måste vara 0 eller större";
        else if(htmlName === 'pulShaftDepthM' && value <= 0)
            return "Schaktdjup PU lining måste vara större än 0";
        else if(htmlName === 'pulSlopeAngleN1' && value === -1)
            return "Släntlutning PU lining måste väljas";
        else if(htmlName === 'pulShaftCapacityM3PerHour' && value <= 0)
            return "Schaktkapacitet PU lining måste vara större än 0";
        else if(htmlName === 'pulShaftLengthM' && value <= 0)
            return "Etapplängd PU lining måste vara större än 0";

        else if(htmlName.startsWith('existingTube')) 
            return this.validateTubeValue(htmlName, value, 'existingTube', 3, false, 'befintligt rör');
        else if(htmlName.startsWith('traditionalTube')) 
            return this.validateTubeValue(htmlName, value, 'traditionalTube', 3, false, 'traditionellt rör');
        else if(htmlName.startsWith('iflTube')) 
            return this.validateTubeValue(htmlName, value, 'iflTube', 2, true, 'infodringsrör');
        else if(htmlName.startsWith('tcTube')) 
            return this.validateTubeValue(htmlName, value, 'tcTube', 3, false, 'rörspräckningsrör');
        else if(htmlName.startsWith('ddTube')) 
            return this.validateTubeValue(htmlName, value, 'ddTube', 3, false, 'styrd borrning');
        else if(htmlName.startsWith('slTube')) 
            return this.validateTubeValue(htmlName, value, 'slTube', 1, false, 'sliplining');
        else if(htmlName.startsWith('pulTube')) 
            return this.validateTubeValue(htmlName, value, 'pulTube', 1, true, 'PU lining');
        
        return true;
    }
    
    validateTubeValue(htmlName: string, value: number, prefix: string, numTubes: number, skipMaterial: boolean, realName: string) : true | string {
        for(let i = 1; i <= numTubes; i++) {
            if(htmlName === `${prefix}${i}TubeType` && value === -1)
                return `Rörtyp ${realName} ${i} måste väljas`;
            else if(!skipMaterial && htmlName === `${prefix}${i}TubeMaterial` && value === -1)
                return `Rörmaterial ${realName} ${i} måste väljas`;
            else if(htmlName === `${prefix}${i}TubeDiameter` && value === -1)
                return `Rördiameter ${realName} ${i} måste väljas`;
            else if(htmlName === `${prefix}${i}TubeLength` && value <= 0)
                return `Rörlängd ${realName} ${i} måste vara större än 0`;
            }
        
        return true;
    }
    

    validateAll(state: PhaseState): ErrorsAndTouched {

        let newStatus = {
            error: state.error,
            touched: state.touched
        };

        newStatus = this.v('techniquesToCompare', state, newStatus);
        if(state.techniquesToCompare !== -1) {
            // Basic info before
            newStatus = this.v('typeOfLandscapeBefore', state, newStatus);
            newStatus = this.v('coatingBefore', state, newStatus);
            if(state.coatingBefore === this.optionManager.ids.COATING_ASPHALT) {
                newStatus = this.v('streetTypeBefore', state, newStatus);
            }
            newStatus = this.validateTubes('existingTube', state.numExistingTubes, state, newStatus, false);
            
            // Basic info after
            newStatus = this.v('typeOfLandscapeAfter', state, newStatus);
            newStatus = this.v('coatingAfter', state, newStatus);
            if(state.coatingAfter === this.optionManager.ids.COATING_ASPHALT) {
                newStatus = this.v('streetTypeAfter', state, newStatus);
                newStatus = this.v('asphaltTypeAfter', state, newStatus);
            }
            
            // Distances
            newStatus = this.v('distanceReceiverFillingKm', state, newStatus);
            if(state.coatingBefore === this.optionManager.ids.COATING_ASPHALT) {
                newStatus = this.v('distanceReceiverCleanAsphaltKm', state, newStatus);
                newStatus = this.v('distanceReceiverPollutedAsphaltKm', state, newStatus);
            }
            newStatus = this.v('distanceFillingKm', state, newStatus);
            newStatus = this.v('distanceAsphaltKm', state, newStatus);
            newStatus = this.v('distanceReceiverOldTubesKm', state, newStatus);

            // Traditional digging
            newStatus = this.v('shaftDepthM', state, newStatus);
            newStatus = this.v('slopeAngleN1', state, newStatus);
            newStatus = this.v('shaftCapacityM3PerHour', state, newStatus);
            newStatus = this.v('shaftLengthM', state, newStatus);
            newStatus = this.validateTubes('traditionalTube', state.numTraditionalTubes, state, newStatus, false);
            
            if(state.shaftLengthM < state.existingTube1TubeLength) {
                newStatus = this.addError('shaftLengthM', 'Schaktlängd traditionell schakt måste vara minst lika lång som rörlängden', newStatus);
            }
            
        }
        
        // Insertion flexible lining
        if(this.dependencyManager.isTechnologyValid(
            this.optionManager.availableSelections.techniquesToCompare, "_IFL", state.techniquesToCompare)) {

            newStatus = this.v('iflPointShafts', state, newStatus);
            if(state.iflPointShafts > 0) {
                newStatus = this.v('iflMetersLongerBottomLengthThanWidth', state, newStatus);
                newStatus = this.v('iflShaftDepthM', state, newStatus);
                newStatus = this.v('iflSlopeAngleN1', state, newStatus);
                newStatus = this.v('iflShaftCapacityM3PerHour', state, newStatus);
                newStatus = this.v('iflShaftLengthM', state, newStatus);
            }

            newStatus = this.validateTubes('iflTube', state.numIflTubes, state, newStatus, true);
        }

        // Tube cracking
        if(this.dependencyManager.isTechnologyValid(
            this.optionManager.availableSelections.techniquesToCompare, "_TC", state.techniquesToCompare)) {

            newStatus = this.v('tcPointShafts', state, newStatus);
            if(state.tcPointShafts > 0) {
                newStatus = this.v('tcMetersLongerBottomLengthThanWidth', state, newStatus);
                newStatus = this.v('tcShaftDepthM', state, newStatus);
                newStatus = this.v('tcSlopeAngleN1', state, newStatus);
                newStatus = this.v('tcShaftCapacityM3PerHour', state, newStatus);
                newStatus = this.v('tcShaftLengthM', state, newStatus);
            }
            newStatus = this.validateTubes('tcTube', state.numTcTubes, state, newStatus, false);
        }
        
        // Tube cracking
        if(this.dependencyManager.isTechnologyValid(
            this.optionManager.availableSelections.techniquesToCompare, "_DD", state.techniquesToCompare)) {

            newStatus = this.v('ddPointShafts', state, newStatus);
            if(state.ddPointShafts > 0) {
                newStatus = this.v('ddMetersLongerBottomLengthThanWidth', state, newStatus);
                newStatus = this.v('ddShaftDepthM', state, newStatus);
                newStatus = this.v('ddSlopeAngleN1', state, newStatus);
                newStatus = this.v('ddShaftCapacityM3PerHour', state, newStatus);
                newStatus = this.v('ddShaftLengthM', state, newStatus);
            }
            newStatus = this.validateTubes('ddTube', state.numDdTubes, state, newStatus, false);
        }

        // Sliplining
        if(this.dependencyManager.isTechnologyValid(
            this.optionManager.availableSelections.techniquesToCompare, "_SL", state.techniquesToCompare)) {

            newStatus = this.v('slPointShafts', state, newStatus);
            if(state.slPointShafts > 0) {
                newStatus = this.v('slMetersLongerBottomLengthThanWidth', state, newStatus);
                newStatus = this.v('slShaftDepthM', state, newStatus);
                newStatus = this.v('slSlopeAngleN1', state, newStatus);
                newStatus = this.v('slShaftCapacityM3PerHour', state, newStatus);
                newStatus = this.v('slShaftLengthM', state, newStatus);
            }

            newStatus = this.validateTubes('slTube', state.numSlTubes, state, newStatus, true);
        }

        // PU lining
        if(this.dependencyManager.isTechnologyValid(
            this.optionManager.availableSelections.techniquesToCompare, "_PUL", state.techniquesToCompare)) {

            newStatus = this.v('pulPointShafts', state, newStatus);
            if(state.pulPointShafts > 0) {
                newStatus = this.v('pulMetersLongerBottomLengthThanWidth', state, newStatus);
                newStatus = this.v('pulShaftDepthM', state, newStatus);
                newStatus = this.v('pulSlopeAngleN1', state, newStatus);
                newStatus = this.v('pulShaftCapacityM3PerHour', state, newStatus);
                newStatus = this.v('pulShaftLengthM', state, newStatus);
            }

            newStatus = this.validateTubes('pulTube', state.numPulTubes, state, newStatus, true);
        }

        newStatus = this.validateNoDigDiameters(state, newStatus);
        
        return newStatus;
    }

    validateNoDigDiameters(state: PhaseState, newStatus: ErrorsAndTouched): ErrorsAndTouched {
        for(let existingTubeIdx = 1; existingTubeIdx <= 3; existingTubeIdx++) {
            let existingTubeType = state[`existingTube${existingTubeIdx}TubeType`];
            if(existingTubeType !== -1) {
                let existingTubeDiameter = state[`existingTube${existingTubeIdx}TubeDiameter`];
                newStatus = this.validateAllNoDigDiametersByType(existingTubeType, existingTubeDiameter, state, newStatus);
            }
        }
        return newStatus;
    }
    
    validateAllNoDigDiametersByType(existingTubeType: number, existingTubeDiameter: number, state: PhaseState, newStatus: ErrorsAndTouched): ErrorsAndTouched {
        if(this.optionManager.isInsertionFlexibleLiningUsed(state.techniquesToCompare))
            for(let iflIdx = 1; iflIdx <= 2; iflIdx++) 
                if(state[`iflTube${iflIdx}TubeType`] === existingTubeType && state[`iflTube${iflIdx}TubeDiameter`] < existingTubeDiameter) 
                    newStatus = this.addError(`iflTube${iflIdx}TubeDiameter`, `Diameter infodringsrör ${iflIdx} måste vara minst lika stor som diameter för ursprungligt rör`, newStatus);

        if(this.optionManager.isTubeCrackingUsed(state.techniquesToCompare))
            for(let tcIdx = 1; tcIdx <= 3; tcIdx++) 
                if(state[`tcTube${tcIdx}TubeType`] === existingTubeType && state[`tcTube${tcIdx}TubeDiameter`] < existingTubeDiameter)
                    newStatus = this.addError(`tcTube${tcIdx}TubeDiameter`, `Diameter rörspräckningsrör ${tcIdx} måste vara minst lika stor som diameter för ursprungligt rör`, newStatus);
            
        // if(this.optionManager.isDirectedDrillingUsed(state.techniquesToCompare))
        //     for(let ddIdx = 1; ddIdx <= 3; ddIdx++) 
        //         if(state[`ddTube${ddIdx}TubeType`] === existingTubeType && state[`ddTube${ddIdx}TubeDiameter`] < existingTubeDiameter)
        //             newStatus = this.addError(`ddTube${ddIdx}TubeDiameter`, `Diameter styrd borrning ${ddIdx} måste vara minst lika stor som diameter för ursprungligt rör`, newStatus);

        if(this.optionManager.isSlipliningUsed(state.techniquesToCompare))
            for(let slIdx = 1; slIdx <= 1; slIdx++)
                if(state[`slTube${slIdx}TubeType`] === existingTubeType && state[`slTube${slIdx}TubeDiameter`] >= existingTubeDiameter)
                    newStatus = this.addError(`slTube${slIdx}TubeDiameter`, `Diameter sliplining ${slIdx} måste vara mindre än diameter för ursprungligt rör`, newStatus);
        
        if(this.optionManager.isPuLiningUsed(state.techniquesToCompare))
            for(let pulIdx = 1; pulIdx <= 1; pulIdx++)
                if(state[`pulTube${pulIdx}TubeType`] === existingTubeType && state[`pulTube${pulIdx}TubeDiameter`] < existingTubeDiameter)
                    newStatus = this.addError(`pulTube${pulIdx}TubeDiameter`, `Diameter PU lining ${pulIdx} måste vara minst lika stor som diameter för ursprungligt rör`, newStatus);
        
        return newStatus;
    }

    validateTubes(prefix: string, numTubes: number, state: PhaseState, newStatus: ErrorsAndTouched, skipMaterial: boolean) {
        for(let i = 1; i <= numTubes; i++) {
            newStatus = this.v(`${prefix}${i}TubeType`, state, newStatus);
            if(!skipMaterial) 
                newStatus = this.v(`${prefix}${i}TubeMaterial`, state, newStatus);
            newStatus = this.v(`${prefix}${i}TubeDiameter`, state, newStatus);
            newStatus = this.v(`${prefix}${i}TubeLength`, state, newStatus);
        }
        return newStatus;
    }

    v(fieldName: string, state: PhaseState, errorsAndTouchedObj: ErrorsAndTouched): ErrorsAndTouched {
        let validationResult = this.validate(fieldName, state[fieldName]);
        return {
            error: this.addValidationResultToErrorObj(errorsAndTouchedObj.error, fieldName, validationResult),
            touched: {...errorsAndTouchedObj.touched, [fieldName]: true}
        };
    }

    addError(fieldName: string, errorString: string, errorsAndTouchedObj: ErrorsAndTouched): ErrorsAndTouched {
        let validationResult = errorString;
        return {
            error: this.addValidationResultToErrorObj(errorsAndTouchedObj.error, fieldName, validationResult),
            touched: {...errorsAndTouchedObj.touched, [fieldName]: true}
        };
    }
    
    addValidationResultToErrorObj(errorObj: {[name:string]: ?string}, name: string, validationResult: boolean | string) {
        let partialErrorObj = this.createPartialErrorObj(name, validationResult);
        return {...errorObj, ...partialErrorObj};
    }
    
    createPartialErrorObj(name: string, validationResult: boolean | string) {
        if(validationResult === true) {
            return {
                [name]: null
            };
        }
        else
        {
            return {
                [name]: validationResult
            };
        }        
    }


}


// WEBPACK FOOTER //
// ./src/common/ValidationManager.js